import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { LocationService } from '../../location/location.service';
import { WorkTypeRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/worktype-remote-action-builder/worktype-remoteaction-builder';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { WorktypesService } from '../../worktypes/logic/worktypes.service';
import { TranslateService } from '@ngx-translate/core';
import { IMSObject } from 'src/app/_model/ims-object';
import { EventService } from '../../event/event.service';

@Injectable({
  providedIn: 'root',
})
export class WorkTypeChangeActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'wtc';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private servicejobService: ServicejobsService,
    private appParameterService: AppParameterService,
    private employeeService: EmployeeService,
    private locationService: LocationService,
    private worktypesService: WorktypesService,
    private translate: TranslateService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(this.constructor.name, 'start wtc with params', params);
    let specificWorkType: IMSObject = undefined;
    if (params?.wtid) {
      specificWorkType = this.worktypesService.getWorktypeById({
        imsId: params?.wtid,
        secondaryId: undefined,
        objRef: 'ims/WorkType',
      });
    }
    let endCurrentWorktype: boolean = false;
    if (params?.endcurrentworktype) {
      endCurrentWorktype = params.endcurrentworktype;
    }
    this.remoteActionBuilderService.newBuild(
      new WorkTypeRemoteActionBuilder(
        this.appService,
        this.credentialsService,
        this.servicejobService,
        this.locationService,
        this.clientStateService,
        this.employeeService,
        this.appParameterService,
        this.worktypesService,
        this.translate,
        this.logger,
        specificWorkType,
        endCurrentWorktype
      )
    );
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
